<template>
  <a-col :span="24" class="itemMail" >
    <a-collapse :bordered="false" :activeKey="opens ? '1' : '0'" @change="getTemplateName">
        <a-collapse-panel  key="1" :showArrow="false" :disabled="keepOpen">
          <template slot="header">

            <a-row type="flex" justify="space-between" align="middle" style="padding: 10px 10px">

              <a-col>
                <a-tooltip placement="top" :title="ESTADOS[mailing.estado].nombre">
                  <a-badge class="estadoBadge" :style="'background:'+ESTADOS[mailing.estado].color" >
                    <a-icon type="mail" />
                  </a-badge>
                </a-tooltip>
              </a-col>

              <a-col :span="6">
                
                <p class="nombre"><b><a-tooltip v-if="mailing.reenvio === true || mailing.reenvio === '1'" placement="top" title="Refuerzo activado"><a-icon type="reload" style="margin-right: 10px"></a-icon></a-tooltip>{{ mailing.nombre }}</b></p>
                <p class="info">{{ getCountryById(mailing.id_pais) ? getCountryById(mailing.id_pais).emoji + ' ' + getCountryById(mailing.id_pais).name : ' - ' }}
                  - {{ mailing.categoria }}</p>
                <p class="info">{{fechaEnvio}}</p>
              </a-col>

              <a-col :span="2">
                <detailHover titulo="#Personas" :valor="format_number(mailing.cantidad_envios)" />
              </a-col>

              <a-col :span="2">
                <detailHover titulo="#Recibidos" :valor="format_number(mailing.deliveries)" :hover="porcentaje(mailing.deliveries, mailing.cantidad_envios)" />
              </a-col>

              <a-col :span="2">
                <detailHover titulo="#Abiertos únicos" :valor="format_number(mailing.opens)" :hover="porcentaje(mailing.opens, mailing.deliveries)" />
              </a-col>

              <a-col :span="2">
                <detailHover titulo="#Clicks únicos" :valor="format_number(mailing.clicks)" :hover="porcentaje(mailing.clicks, mailing.deliveries)"/>
              </a-col>

              <a-col :span="2">
                <detailHover titulo="#Conversiones" :valor="format_number(mailing.conversions)" :hover="porcentaje(mailing.conversions, mailing.deliveries)"/>
              </a-col>

              <a-col :span="2">
                <detailHover titulo="#Unsuscribes" :valor="format_number(mailing.unsuscribes)" :hover="porcentaje(mailing.unsuscribes, mailing.deliveries)"/>
              </a-col>

              <a-col :span="2">
                <detailHover titulo="Costo" :valor="'USD '+format_number(mailing.costo)" />
              </a-col>
              <a-col :span="1">
                <a-dropdown placement="bottomCenter">
                  <a class="ant-dropdown-link">
                    <a-col :span="24">
                      <a-icon onclick="event.stopPropagation()" type="ellipsis" style="font-size: 20px" />
                    </a-col>
                  </a>
                  <a-menu slot="overlay">

                    <a-menu-item>
                      <router-link :to="'/ampliado/' + mailing.id"><a-icon type="fullscreen" />
                      Ampliar
                      </router-link>
                    </a-menu-item>

                    <a-menu-item @click="downloadData" v-if="mailing.estado === 'ENVIADO'">
                      <a-icon type="download" />
                      Descargar
                    </a-menu-item>

                    <a-menu-item @click="verPreview()">
                      <a-icon type="eye"/>
                      Ver Email
                    </a-menu-item>

                    <a-menu-item v-if="mailing.estado != 'ENVIADO' && mailing.estado != 'CANCELADO' ">
                      <router-link :to="'/email/actualizar/' + mailing.id"><a-icon type="edit" />
                      Editar
                      </router-link>
                    </a-menu-item>

                    <a-menu-item v-if="mailing.estado != 'REVISION'">
                      <router-link :to="'/email/duplicar/' + mailing.id">
                        <a-icon type="copy" />
                        Duplicar
                      </router-link>
                    </a-menu-item>

                    <a-menu-item v-if="mailing.estado == 'ENVIADO'">
                      <router-link :to="'/email/reenviar/' + mailing.id">
                        <a-icon type="redo" />
                        Crear Reenvío
                      </router-link>
                    </a-menu-item>

                    <a-menu-item 
                      @click="visibleSendTest = true"
                      v-if="mailing.estado == 'ESPERANDO_APROBACION' || mailing.estado == 'BORRADOR' || mailing.estado == 'REVISION'" >
                      <a-icon type="mail" />
                      {{ mailing.estado == 'BORRADOR'? 'Enviar Prueba' : 'Reenviar Prueba' }}
                    </a-menu-item>

                    <a-menu-item @click="showCancelConfirm(mailing.id)" v-if="mailing.estado != 'ENVIADO' && mailing.estado != 'CANCELADO' && mailing.estado != 'BORRADOR'">
                      <a-icon type="close-circle" />
                      Cancelar
                    </a-menu-item>

                    <a-menu-item @click="showDeleteConfirm(mailing.id)" v-if="mailing.estado == 'ENVIADO' || mailing.estado == 'CANCELADO' || mailing.estado == 'BORRADOR'">
                      <a-icon type="delete" />
                      Eliminar 
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>

              </a-col>
            </a-row>
          </template>

        <a-row type="flex" justify="space-between" :gutter="40" style="padding: 10px; padding-bottom: 0px;">
          <a-col :span="9">
            <a-row type="flex" justify="start" align="top" :gutter="20" class="caracteristicas" style="margin-bottom: 20px">
              <a-col class="title"><a-icon type="user" class="icon"  />From</a-col>
              <a-col class="info">{{ mailing.from_name }}<br/>{{ mailing.from_mail }}</a-col>
            </a-row>
            <a-row type="flex" justify="start" align="top" :gutter="20" class="caracteristicas">
              <a-col class="title"><a-icon type="undo" class="icon" />Reply To</a-col>
              <a-col class="info">{{ mailing.reply_to }}</a-col>
            </a-row>
            <a-row type="flex" justify="start" align="top" :gutter="20" class="caracteristicas">
              <a-col class="title"><a-icon type="align-left" class="icon" />Asunto</a-col>
              <a-col class="info" style="max-width: calc(100% - 100px)">{{ mailing.asunto }}<br/>{{ mailing.preview_text }}</a-col>
            </a-row>
          </a-col>
          <a-col :span="9">
            <a-row type="flex" justify="start" align="top" :gutter="20" class="caracteristicas">
              <a-col class="title"><a-icon type="database" class="icon" />Base de Datos</a-col>
              <a-col class="info" style="width: calc(100% - 25px); margin-left: 25px">
               <strong>LISTAS INCLUIDAS</strong> <span v-for="lista in listas_incluir" :key="lista.id"> <strong> - </strong>{{ lista.nombre }}</span>
                <br/>
                <strong>LISTAS EXCLUIDAS</strong> <span v-for="lista in listas_excluir" :key="lista.id"> <strong> - </strong>{{ lista.nombre }}</span>
                <br/>
                <strong>EMAILS EXCLUIDOS</strong> <span v-for="mail in mailings_excluir" :key="mail.id"> <strong> - </strong>{{ mail.nombre }}</span>
              </a-col>
            </a-row>

            <a-row type="flex" justify="start" align="top" :gutter="20" class="caracteristicas">
              <a-col class="title"><a-icon type="file-text" class="icon" />Template</a-col>
              <a-col class="info" style="width: calc(100% - 120px)">
                  <a @click="verPreview(mailing.id)" href="#">&nbsp;<a-spin :spinning="loadingTemplateName"></a-spin>{{ template_name }}</a>
              </a-col>
            </a-row>
          </a-col>

          <a-col :span="6">
            
            <a-timeline mode="right">
              <a-timeline-item><b>Creado</b><br/> el {{ fecha_completa(mailing.creado_el) }}<br/>por {{ mailing.creado_por }}</a-timeline-item>
              <a-timeline-item v-if="mailing.aprobado_el != null"><b>Aprobado</b><br/> el {{ fecha_completa(mailing.aprobado_el) }}<br/>por {{ mailing.aprobado_por }}</a-timeline-item>
              <a-timeline-item > <b> </b><br/>{{fechaEnvio}}</a-timeline-item>
            </a-timeline>
          </a-col>
        </a-row>
          <br><br>
          <a-row v-if="insights" >
            <a-col :span="10" v-if="showPieChart">
              <StatusSummary :mailing="mailing"></StatusSummary>
            </a-col>
            <a-col :span="12" v-if="mailing.abtest" style="float: right">
              <ABtestResults :mailing="mailing"></ABtestResults>
            </a-col>
            <a-col :span="showPieChart && mailing.abtest ? 24 : 12" style="margin-top: 10px; float: right" >
              <EmailInsights :mailing="mailing"></EmailInsights>
            </a-col>


          </a-row>

        </a-collapse-panel>

    </a-collapse>

    <a-drawer
        :title="mailing.nombre"
        placement="right"
        @close="visiblePreview = false"
        :visible="visiblePreview"
        width="40%"
      >
      <div v-html="mailing.html"></div>
      <a-icon v-if="loading" class="loading" style="font-size: 100px;" type="loading" />
        
    </a-drawer>


      <a-modal title="Ingrese los email que recibirán una prueba" v-model="visibleSendTest">
        <a-spin tip="Cargando..." :spinning="loadingSendTest">
          <a-form>
            <a-textarea
                v-decorator="['emails', formularioRules.email]"
                v-model="formSendTest.emails"
                placeholder="Ingrese los email que recibirán la prueba separados por comas"
                :autosize="{ minRows: 2, maxRows: 6 }" />
          </a-form>
        </a-spin>
        <template slot="footer">
          <a-button key="back" @click="visibleSendTest = false">Cerrar</a-button>
          <a-button html-type="submit" @click="submitPrueba(mailing.id)"  type="primary">Enviar Prueba</a-button>
        </template>

      </a-modal>



  </a-col>
 
</template>

<script>
import moment from 'moment'
import detailHover from './DetailHover.vue'
import utils from '../service/service.js'
import VueApexCharts from 'vue-apexcharts'
import Vue from "vue";
import EmailInsights from "@/components/EmailInsights.vue";
import ABtestResults from "@/components/ABtestResults.vue";
import axios from "axios";
import countries from "@/service/countries";
import StatusSummary from "@/components/StatusSummary.vue";

Vue.component('apexchart', VueApexCharts)

moment.locale('ES');

export default {
  name: 'itemMail',
  components: {
    StatusSummary,
    ABtestResults,
    EmailInsights,
    detailHover,
  },
  props: {
    mailing: {},
    mailings: {},
    listas: {},
    opens: {
      type: Boolean,
      default: false
    },
    keepOpen: {
      type: Boolean,
      default: false
    },
    insights: {
      type: Boolean,
      default: false
    },

  },
  mixins:[utils, countries],
  data() {
    return {
      visiblePreview: false,
      visibleSendTest: false,
      loading:'',
      loadingSendTest: false,
      formSendTest: {
        emails: ''
      },
      formularioRules:{
        email: { rules: [{ required: true, message: 'Ingrese al menos 1 Email'}]}
      },
      listas_incluir:[],
      listas_excluir:[],
      mailings_excluir:[],
      template_name: '',
      loadingTemplateName: false,

  }
  },
  mounted: function() {
    this.formSendTest.emails = JSON.parse(localStorage.getItem('test_emails'));
    this.mapListas();
    this.mapMailings();
    if(this.opens) {
      this.getTemplateName();
    }

  },
  methods:{
    getTemplateName() {
      if(this.template_name !== '') return;

      this.loadingTemplateName = true;
      this.sendRequest({
        method: "GET",
        url:'templates/' + this.mailing.template_id
      }).then(({data}) => {
        this.loadingTemplateName = false;
        this.template_name = data.settings.title
      })
    },
    promedio(costo, cantidad_envios){
      if(cantidad_envios > 0){
        return 'USD '+ (costo / cantidad_envios).toFixed(2);
      }else
        return '-';
    },
    porcentaje(cantidad, total){
      if(total>0){
        cantidad = parseInt(cantidad);
        total = parseInt(total);
        var resultado = ((cantidad / total) * 100).toFixed(2);
        return resultado + '%';
      }else
        return '-'
    },
    async downloadData() {
      try {

        const data = await this.sendRequest({
          method: 'GET',
          url: "mailings/data/download/" + this.mailing.id,
        })

        const blob = new Blob([data], {
          type: "application/csv",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "mailing_"+this.mailing.id+".csv";
        link.click();
      } catch (error) {
        this.$message.error(error)
      }
    },
     mapListas(){
      var $this = this;

        if(this.mailing.id_listas_excluir.length > 0){
          this.listas_excluir = this.listas.filter(x =>{
            return this.mailing.id_listas_excluir.includes(x.id);
          });
        } else {
          this.listas_excluir = [];
        }
        if($this.mailing.id_listas_incluir.length > 0){
          $this.listas_incluir = $this.listas.filter(x =>{
            return $this.mailing.id_listas_incluir.includes(x.id);
          });
        } else {
          this.listas_incluir = [];
        }
    },
    mapMailings(){
        if(this.mailing.id_mailings_excluir.length > 0){
          this.mailings_excluir = this.mailings.filter(x=>{
            return this.mailing.id_mailings_excluir.includes(x.id);
          });
        } else {
          this.mailings_excluir = [];
        }
    },

    fecha_completa(fecha){
      return moment(fecha, 'YYYY/MM/DD hh:mm:ss SSS', 'es').format('LLL');
    },
    showDeleteConfirm(id) {
      var $this = this;
      this.$confirm({
        title: '¿ Estas seguro que queres eliminar este email?',
        content: 'Una vez eliminado este email se perdera registro del mismo.',
        okText: 'Si',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          $this.sendRequest({
            method: 'POST',
            url:'mailings/delete/' + id
          }).then(() => {
            window.location.reload(false);
          })
        },
        onCancel() {
        },
      });
    },
    showCancelConfirm(id) {
      const $this = this;
      this.$confirm({
        title: '¿Estas seguro que queres eliminar este email?',
        content: 'Una vez cancelado, el email no se podra reactivar. Si podra realizar otras acciones sobre el email como duplicar.',
        okText: 'Si',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          $this.sendRequest({
            method:"POST",
            url:'mailings/cancel/' + id
          }).then(({ data }) => {
            $this.listas = data;
            window.location.reload();
          })
        },
        onCancel() {
        },
      });
    },
    verPreview(){
      this.loading = true;
      this.sendRequest({
        method:'GET',
        url:'mailings/render/' + this.mailing.id
      }).then(({ data }) => {
        this.mailing.html = data;
        this.loading = false;
      })
      this.visiblePreview = true;
    },
    submitPrueba(id){
      this.loadingSendTest = true;
      const emails = this.formSendTest.emails;
      const $this = this;
      //actualizo
      this.sendRequest({
        method: 'POST',
        url: 'mailings/test/' + this.mailing.id,
        data: {info: emails}
      }).then(() => {
        this.loadingSendTest = false;
        this.$message.success("Prueba Enviada");
        this.visibleSendTest = false;
      })
      .catch((error) => {
        $this.$message.error(error);
      });
    },
  },computed:{
    fechaEnvio: function () {
      var $this = this
      var date = $this.mailing.estado == 'ENVIADO' && this.mailing.sent_at ? this.mailing.sent_at :  $this.mailing.fecha_envio
      var today = moment().format(today,'YYYY/MM/D hh:mm:ss LLL')
      date = moment().format(date,'YYYY/MM/D hh:mm:ss LLL')
      if (date < today && $this.mailing.estado == 'ENVIADO') {
        return "Enviado el " + moment(date, 'YYYY-MM-DD hh:mm:ss', 'es').format('LLL');
      }
      else{
        return "Programado para el " + moment(date, 'YYYY-MM-DD hh:mm:ss', 'es').format('LLL');
      }
    },
    showPieChart: function() {
      return parseInt(this.mailing.complaints)+
          parseInt(this.mailing.bounces)+
          parseInt(this.mailing.blacklists) > 0
    }

  },
  watch: {
    listas: function() {
      this.mapListas();
    },
    mailings: function() {
      this.mapMailings();
    },
    mailing: function() {
      this.mapMailings();
      this.mapListas();
    },
    opens: function() {
      //console.log('open change');
    },
    formSendTest: {
      handler() {
        localStorage.setItem('test_emails', JSON.stringify(this.formSendTest.emails));
      },
      deep: true,
    },
  }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .estadoBadge {
    width: 42px;
    height: 42px;
    border-radius: 4px;
    color: white;
    background: #ededed;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  p {
    margin-bottom: 0px;
  }
  p.nombre {
      text-align: left;
      font-size: 16px;
  }
  p.info {
      text-align: left;
      font-size: 12px;
      margin-top: 3px;
  }
  .itemMail{
    margin-bottom: 20px;
  }
  .ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header{
    border-bottom: 0px;
    box-shadow: 2px 1px 5px -4px;
  }
  .contenido_description{
    margin-left: 5%;
    padding-left: 7px;
    text-align: left;
    margin-bottom: 15px;
  }
  .caracteristicas{
    margin-bottom: 20px
  }
  .caracteristicas .title{
    font-size: 16px;
    color: #333333;
  }
  .caracteristicas .icon{
    margin-right: 10px;
  }
  .caracteristicas .info{
    text-align: left;
  }

  .caracteristicas .info{
    text-align: left;
  }
  .loading{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style>